import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import QuizTestCard from "../../common/QuizTestCard.jsx";
import Loader from "../../../../../shared_components/Loader.jsx";

import {getQuizTestsList} from "../../../actions/operations.js";

const QuizTestsList = () => {
  const dispatch = useDispatch();
  const { quizTestsList, quizTestsListLoading} = useSelector(
    (state) => state.quizTest,
  );
  const [dropdown, setDropdown] = useState(true);
  const [previousDropdown, setPreviousDropdown] = useState(true);

  useEffect(() => {
    dispatch(getQuizTestsList());
  }, [dispatch]);

  // Filter available and previously taken tests
  const availableTests = quizTestsList?.filter(
    (item) =>
      item?.quizCategory?.toLowerCase() === "quiztest" &&
      item?.isAttempted === false && item?.quizQuestions?.length > 0
  );

  const previousTests = quizTestsList?.filter(
    (item) =>
      item?.quizCategory?.toLowerCase() === "quiztest" &&
      item?.isAttempted === true
  );

  return (
    <div className='quiz-list-body'>
      {quizTestsListLoading ? (
        <Loader />
      ) : (
        <>
          <div className='container'>
            <div className='pt-3 mb-4 '>
              <Link
                to='/quiz'
                className='back-link d-inline-flex align-items-center text-white back-hover cursor-pointer'
              >
                <i className='bi bi-arrow-left me-2'/>
                Back to Tests
              </Link>
            </div>

            <div className='section-container bg-default'>
              <div
                onClick={() => {
                  setDropdown(!dropdown);
                }}
                className='d-flex align-items-center section-header'
                data-bs-toggle='collapse'
                data-bs-target='#availableTests'
              >
                {dropdown ? (
                  <i className='bi bi-chevron-compact-up'></i>
                ) : (
                  <i className='bi bi-chevron-compact-down'></i>
                )}
                <h5 className='mx-3 text-white'>Available Tests</h5>
              </div>

              <div className='collapse show' id='availableTests'>
                <div className='card-container col-lg-12 col-12 d-lg-flex flex-lg-wrap'>
                  {availableTests?.length > 0 ? ( 
                    availableTests.map((item, index) => (
                      <div
                        className='quiz-card-wrapper p-2'
                        key={item?._id || index}
                      >
                        <QuizTestCard item={item} index={index} />
                      </div>
                    ))
                  ) : (
                    <p className='no-tests-message w-100 text-center '>
                      No available tests at the moment.
                    </p>
                  )}
                </div>
              </div>
            </div>

            <div className='section-container'>
              <div
                onClick={() => {
                  setPreviousDropdown(!previousDropdown);
                }}
                className='d-flex align-items-center section-header '
                data-bs-toggle='collapse'
                data-bs-target='#previoustest'
              >
                {previousDropdown ? (
                  <i className='bi bi-chevron-compact-up'></i>
                ) : (
                  <i className='bi bi-chevron-compact-down'></i>
                )}{" "}
                <h5 className='mx-3'>Previously Taken Tests</h5>
              </div>

              <div className='collapse show' id='previoustest'>
                <div className='card-container col-lg-12 col-12 d-lg-flex flex-lg-wrap'>
                  {previousTests?.length > 0 ? (
                    previousTests.map((item, index) => { 
                      return (
                        <div
                          className='quiz-card-wrapper p-2'
                          key={item?._id || index}
                        >
                          <QuizTestCard
                            item={item}
                            index={index}
                            disable={true}
                            certificateUrl={item?.certificateUrl}//error
                            prev={true}
                            ispassed={item?.ispassed}
                          />
                        </div>
                      );
                    })
                  ) : (
                    <p className='no-tests-message w-100 text-center'>
                      You have not taken any tests yet.
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default QuizTestsList;
